<template>
    <div style="width: 100%">
        <div class="row">
            <div class="col-md-9"><h1 class="header-title">Archives</h1></div>
        </div>
        <loader :loading="isLoading" v-if="isLoading"></loader>
        <div class="full logs" v-if="currentTab">
            <ul class="nav nav-tabs">
                <li v-for="tab in tabs" :key="tab.id" class="nav-item">
                    <button class="nav-link" :class="tab.id === currentTab.id ? 'active' : ''" @click="selectTab(tab)">
                        {{ tab.name }}
                    </button>
                </li>
            </ul>
            <section class="content_logs" :key="currentTab.id">
                <div class="table-responsive mt-4">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>File</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="file in files" :key="file.id">
                                <td class="px-3">{{ getDateByFormat(file.date, "DD/MM/YYYY - HH:mm") }}</td>
                                <td class="px-3">{{ file.formatFileName }}</td>
                                <td class="px-3">
                                    <ClientColorButton :inactive-color="true" @click="downloadFile(file)">Download</ClientColorButton>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.header-title {
    color: #6f6f6f;
    font-size: 30px;
    margin: 0 0 30px;
    text-transform: uppercase;
    font-family: "Oswald", sans-serif;
    font-weight: normal;
    display: block;
}
.logs {
    ul.nav {
        width: 100%;
        button {
            background-color: transparent;
            display: block;
            font-size: 16px;
            padding: 15px;
            color: #495057;
            font-weight: 600;
            &.active {
                background-color: white;
            }
            &:focus {
                outline: none;
            }
        }
    }

    .content_logs {
        background-color: white;
        padding: 50px 20px 50px;
    }

    table {
        margin-top: 25px;
        border-collapse: collapse;
        tr {
            td {
                text-align: center;
                padding: 15px 10px;
                vertical-align: middle;
                overflow-wrap: break-word;
                color: black;
                font-size: 19px;
                line-height: 20px;
                transition: 0.3s ease-in-out;
                font-weight: 500;
                span.file {
                    text-transform: initial;
                    cursor: pointer;
                    font-size: 19px;
                    color: black;
                    text-decoration: underline;
                    text-decoration-color: black;
                }
                .badge {
                    border-radius: 4px;
                    span {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 10px 0;
                        width: 90px;
                    }
                }
            }

            th {
                font-family: "Oswald", sans-serif;
                font-size: 19px;
                background: #343434;
                border: #343434 1px solid;
                color: #fff;
                text-transform: uppercase;
                text-align: center;
                vertical-align: center;
                padding: 15px 10px;
                font-weight: normal;
                @media (max-width: 1440px) {
                    font-size: 16px;
                }
            }
        }
    }
}
</style>

<script>
import AdminTools from "@/components/adminTools/Admin";
import TryLoad from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import { LOG_STATUS } from "@/components/admin/logs/constants";
import Globals from "@/components/globals";
import Axios from "axios";
import LogContent from "@/components/admin/logs/LogContent";
import applicationLinkService from "@/services/applicationLink";
import http from "@/services/http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    data: () => ({
        tabs: [
            { id: 1, name: "BI_LAUNCH_QTY" },
            { id: 2, name: "IBP_LAUNCH" },
            { id: 3, name: "IBP_LAUNCH_M18" },
            { id: 4, name: "BI_CATALOG" },
            { id: 5, name: "S4_CATALOG" }
        ],
        currentTab: null,
        files: [],
        isLoading: false,
        modalEditProfile: null,
        modalCreateProfile: null,
        paramsModalLogContent: null
    }),
    components: {
        LogContent,
        AdminTools,
        loader
    },
    mixins: [TryLoad],
    created() {
        this.currentTab = this.tabs[0];
    },
    methods: {
        downloadFile(file) {
            Axios.get(Globals.getBaseUrl() + `/exports` + file.fileLink, { responseType: "arraybuffer" })
                .then(response => {
                    const blob = new Blob([response.data], { type: "text/csv" });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = file.formatFileName;
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
                .catch(console.error);
        },
        async loadFiles(tab) {
            this.isLoading = true;

            try {
                const res = await http.get(buildUrlFromLocation(`/admin/csv/${tab.name}`));

                this.files = res;
                this.dialogSuccess();
            } catch (e) {
                console.error(e);
                this.files = [];
                this.dialogError();
            } finally {
                this.isLoading = false;
            }
        },
        async selectTab(tab) {
            this.currentTab = tab;
            await this.loadFiles(tab);
        }
    },
    created() {
        this.selectTab(this.tabs[0]);
    }
};
</script>



// WEBPACK FOOTER //
// ExportExcel.vue?524fee1a